import React from "react";
import { useNavigate } from "react-router-dom";
import "./CancellationConfirmation.css";

function CancellationConfirmation() {
  const navigate = useNavigate();

  const handleHome = () => {
    navigate("/");
  };

  return (
    <div className="scheduler-container">
      {/* Top bar with company logo */}
      <div className="top-bar">
        <div className="logo">
          <img src="/colt-single-logo.png" alt="Colt Home Services" />
        </div>
      </div>
      <div className="cancellation-content">
        <h2>Appointment Cancelled</h2>
        <p>
          Your appointment has been successfully cancelled.
        </p>
        <button className="home-button" onClick={handleHome}>
          Return to Home
        </button>
      </div>
    </div>
  );
}

export default CancellationConfirmation;
